import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
    MultiSecurityQuickflowCollectionResponse,
    MultiSecurityQuickflowListResponse,
    QuickflowRedirectResponse,
    SingleSecurityQuickflowCollectionResponse,
} from 'QuickflowsApp/ts/interfaces/quickflow-view-responses.interface';

import { AjaxService } from 'Angular/services/core/ajax.service';
import { UrlsService } from 'Angular/services/core/urls.service';

@Injectable({
    providedIn: 'root',
})
export class QuickflowsService {
    constructor(private ajaxService: AjaxService, private urlsService: UrlsService) {}

    getSingleSecurityQuickflowsCollection(securityId: string): Observable<SingleSecurityQuickflowCollectionResponse[]> {
        const url = this.urlsService.getUrl(this.urlsService.QUICKFLOWS.SINGLE_SECURITY.QUICKFLOWS_COLLECTION);
        const getParams = { securityId };
        return this.ajaxService.getDataObserveBody<SingleSecurityQuickflowCollectionResponse[]>(url, getParams);
    }

    getSingleSecurityQuickflowsRedirect(
        quickflowId: string,
        securityId: string
    ): Observable<QuickflowRedirectResponse> {
        const urlParams = { quickflowId };
        const url = this.urlsService.getUrl(this.urlsService.QUICKFLOWS.SINGLE_SECURITY.QUICKFLOWS_REDIRECT, urlParams);

        const getParams = { securityId };
        return this.ajaxService.getDataObserveBody<QuickflowRedirectResponse>(url, getParams);
    }

    getMultiSecurityQuickflowsCollection(securityIds: string): Observable<MultiSecurityQuickflowCollectionResponse[]> {
        const url = this.urlsService.getUrl(this.urlsService.QUICKFLOWS.MULTI_SECURITY.QUICKFLOWS_COLLECTION);
        const getParams = { securityIds };
        return this.ajaxService.getDataObserveBody<MultiSecurityQuickflowCollectionResponse[]>(url, getParams);
    }

    getMultiSecurityQuickflowsList(): Observable<MultiSecurityQuickflowListResponse> {
        const url = this.urlsService.getUrl(this.urlsService.QUICKFLOWS.MULTI_SECURITY.QUICKFLOWS_LIST);
        return this.ajaxService.getDataObserveBody<MultiSecurityQuickflowListResponse>(url);
    }

    putMultiSecurityQuickflowsList(securityIds: string): Observable<void> {
        const url = this.urlsService.getUrl(this.urlsService.QUICKFLOWS.MULTI_SECURITY.QUICKFLOWS_LIST);
        const putParams = { securityIds };
        return this.ajaxService.putDataObserveBody(url, putParams);
    }

    getMultiSecurityQuickflowsRedirect(
        quickflowId: string,
        securityIds: string
    ): Observable<QuickflowRedirectResponse> {
        const urlParams = { quickflowId };
        const url = this.urlsService.getUrl(this.urlsService.QUICKFLOWS.MULTI_SECURITY.QUICKFLOWS_REDIRECT, urlParams);

        const getParams = { securityIds };
        return this.ajaxService.getDataObserveBody<QuickflowRedirectResponse>(url, getParams);
    }
}
